import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { createSelector } from 'reselect';
import { toggleFbBusinessAuthModal } from '../../../../slices/modals/reducer';
import { createFacebookBusinessAuth } from '../../../../slices/publish/facebook/thunk';

function BusinessAuthNeedModal() {
  const dispatch = useDispatch();
  const selectModalState = createSelector(state => state, state => ({
    fbBusinessAuthModal: state.Modal.fbBusinessAuthModal
  }));
  const { fbBusinessAuthModal } = useSelector(selectModalState);

  function closeModal() {
    dispatch(toggleFbBusinessAuthModal());
  }

  return (
    <Modal isOpen={fbBusinessAuthModal} toggle={closeModal} centered size='sm'>
      <ModalHeader className='p-3' toggle={closeModal}>
        Authentication Needed
      </ModalHeader>
      <ModalBody className='text-dark'>
        The selected business is not authenticated. Please authenticate your business to proceed with publishing on Facebook Catalog Publish.
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' onClick={closeModal}>Close</button>
        <button className='btn btn-success' onClick={() => dispatch(createFacebookBusinessAuth())}>
          Authenticate
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default BusinessAuthNeedModal
